import { FunctionComponent, ReactNode } from 'react'
import { Wrapper, StatusWrapper } from './Status.style'
import { useTranslation } from 'react-i18next'
import { statusIconHelper } from './Status.helper'

interface IStatusProps {
  status?: string
  date?: any
  preKeyForTranslation?: string
  type?: string
  border?: boolean
  tripId?: string
  suffixComponent?: ReactNode
}

const Status: FunctionComponent<IStatusProps> = ({
  tripId,
  status,
  date,
  preKeyForTranslation,
  type,
  border,
  suffixComponent,
}) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <StatusWrapper>
        {statusIconHelper(status)}
        <p>
          {status === '-'
            ? status
            : `${t(`${preKeyForTranslation}.${status?.toLocaleUpperCase?.()}`)}${
                tripId ? `: ${tripId}` : ''
              }`}
        </p>
        {suffixComponent}
      </StatusWrapper>
      {date && <span>{date}</span>}
    </Wrapper>
  )
}

Status.defaultProps = {
  status: '',
  preKeyForTranslation: '',
  type: '',
}

export default Status
